var _title, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    "aria-labelledby": "headerStoreIcon headerStoreDesc",
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icone de loja do header")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.637.765c.683 0 1.28.306 1.673.8l2.523 5.602c.112.222.168.444.168.666v3.334c0 .93-.546 1.734-1.334 2.108v7.892a1 1 0 01-2 0V13.5h-6v6.1c0 1.418-1.044 2.567-2.333 2.567H3.667c-1.289 0-2.333-1.15-2.333-2.566v-6.326A2.333 2.333 0 010 11.167V7.833c0-.222.056-.444.166-.666l2.51-5.602a2.162 2.162 0 011.688-.8h15.273zm2.03 10.735c.184 0 .333-.15.333-.333V8.5h-3.5v3h3.167zm-.328-5l-1.682-3.734H4.364c-.012 0-.024 0-.034.002L2.657 6.5h18.682zm-8.338 2h3.5v3H13v-3zm-2 0H7.5v3H11v-3zm-5.5 0H2v2.667c0 .184.149.333.333.333H5.5v-3zm-2.167 5.036h9.333v6.065c0 .352-.194.566-.333.566H3.667c-.14 0-.333-.214-.333-.566v-6.065z",
    fill: "#fff"
  })));
}

export default SvgHeaderStore;